import { makeStyles } from '@mui/styles';

export const muiStyles = makeStyles(() => ({
    totalBalanceContainer: {
        backgroundColor: '#fff',
        fontSize: '12px',
        padding: '5px 0px 3px 24px'
    },
    totalBalanceTitle: {
        paddingRight: '30px',
        fontWeight: 'bold'
    },
    seeDetailsButton: {
        width: '96px',
        height: '18px',
        padding: '12px auto 10px auto',
        color: '#FFF',
        textAlign: 'center' as const,
        fontSize: '9px'
    },
    infoText: {
        padding: '24px',
        fontSize: '12px',
        fontStyle: 'italic',
        backgroundColor: '#fff',
        color: '#757575',
        '& a, a:hover, a:visited': { fontWeight: 'bold' }
    },
    seeDetailsButtonContainer: {
        backgroundColor: '#fff',
        padding: '12px 0 10px 0'
    },
    anchorText: {
        textDecorationLine: 'none' as const,
        color: '#547dbf"'
    },
    agHeaderCell: {
        marginLeft: '12px',
        marginRight: '12px',
        padding: '6px'
    }
}));